import { Box } from "../box";
import { type DividerProps } from "./types";
import { useTheme } from "@repo/tokens";

export const Divider = ({
  orientation = "horizontal",
  thickness = 1,
  color,
  style,
  ...props
}: DividerProps) => {
  const { theme } = useTheme();
  const borderColor = color || theme.border.default;

  return (
    <Box
      style={{
        width: orientation === "horizontal" ? "100%" : thickness,
        height: orientation === "vertical" ? "100%" : thickness,
        backgroundColor: borderColor,
        ...(style as React.CSSProperties),
      }}
      {...props}
    />
  );
};
